import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import * as React from 'react';

import ReactRenderer from '../shared/react/react-renderer';
import { EventService } from '../shared/services/event.service';
import { AngularEvents } from '../shared/shared-context/angular-events';
import { ClassNameHandler } from './class-name-handler';
import { OfficeHomeFluentThemeProvider } from './officehome-fluent-theme-provider';

@Directive({ selector: 'ohp-fluent-theme-provider-content' })
export class FluentThemeProviderContentDirective extends ReactRenderer implements OnInit, OnDestroy {

    private readonly classNameHandler: ClassNameHandler;

    constructor(
        elementRef: ElementRef,
        eventService: EventService
    ) {
        super(elementRef);
        this.classNameHandler = (className: string) => {
            eventService.broadcastEvent({ name: AngularEvents.fluentClassNameChanged, args: [className]});
        };
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        if (!React) {
            return null;
        }

        return (
            <OfficeHomeFluentThemeProvider classNameHandler={this.classNameHandler}/>
        );
    }
}
